import { useState, useRef, useEffect } from "react";
import { ExtraSmallDateFormat } from '../utils/date_format.js'
import { LoadMatchDays } from "../repo/MatchesRepo.js";

export default function MatchesDay({groupId, ...props}) {
  const [scrollPosition, setScrollPosition] = useState(100);
  const [days, setDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const containerRef = useRef();

  async function loadDays(groupId) {
    const resData = await LoadMatchDays(groupId)

    setSelectedDay(resData.data.selected_date)
    setDays(resData.data.dates)
  }

  const ITEM_WIDTH = 100;

  const handleScroll = (scroollAmount) => {
    let newPosition = scrollPosition + scroollAmount;
    if (newPosition < 0) {
      newPosition = 0;
    }

    if (newPosition + containerRef.current.clientWidth >= containerRef.current.scrollWidth + ITEM_WIDTH) {
      newPosition = scrollPosition;
    }
    setScrollPosition(newPosition);
    containerRef.current.scrollLeft = newPosition;
  }

  const handleDayClick = (day) => {
    const containerWidth = document.getElementById('match-days-scroll-container').offsetWidth;
    let scrollTo = (days.indexOf(day) * 116 - (containerWidth / 2)) + 50;
    if (scrollTo < 0) {
      scrollTo = 0;
    } else if (scrollTo + containerWidth >= containerRef.current.scrollWidth) {
      scrollTo = containerRef.current.scrollWidth - containerWidth;
    }
    document.getElementById('match-days-scroll-container').scrollTo({
      left: scrollTo,
      behavior: 'smooth'
    });

    setScrollPosition(scrollTo);
    containerRef.current.scrollLeft = scrollTo;

    props.onDayClick(day)
    setSelectedDay(day)
  }

  useEffect(() => {
    if (!days || days.length === 0) {
      loadDays(groupId)
    } else {
      handleDayClick(selectedDay)
    }
  }, [days])

  return (
    <div className="flex flex-row items-center justify-center px-1 py-2 mb-4 mx-4 bg-white rounded-lg border-slate-300 border">
      {days.length > 0 && (
        <>
          <div className="w-8">
            <button className="mx-1 w-6 rounded-full bg-green-600 text-white hover:bg-green-300" onClick={() => handleScroll(-ITEM_WIDTH)}>{"<"}</button>
          </div>

          <div ref={containerRef} id="match-days-scroll-container" className="w-full overflow-x-hidden scroll-smooth">
            <div className="flex justify-between space-x-4">
              {days.map((day) => (
                <div id={"date-day-" + day} key={"date-day-" + day}>
                  <div className={`w-[100px] text-center p-2 rounded-full cursor-pointer text-xs hover:bg-green-200 hover:font-bold ${day === selectedDay ? "bg-green-500 font-bold border-green-800 border-2" : "bg-green-300"}`} onClick={() => handleDayClick(day)}>
                    <span>{ExtraSmallDateFormat(day + " 00:00:00")}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="w-8">
            <button className="mx-1 w-6 rounded-full bg-green-600 text-white hover:bg-green-300" onClick={() => handleScroll(ITEM_WIDTH)}>{">"}</button>
          </div>
        </>
      )}
      {days.length === 0 && ("Carregando...")}
    </div>
  )
}
